import { EXTERNAL_NAME } from '@meltwater/mw-visualizations/cjs/build-info';
import * as MWV from '@meltwater/mw-visualizations';

export default function() {
    window[EXTERNAL_NAME] = MWV;
}
